/* eslint-disable @typescript-eslint/semi */
import { Photo } from '@capacitor/camera'

export class User {

  __iAm: string = "User"

  id: string
  image: Photo
  imageBase64String: string

  firstname: string
  lastname: string
  country: string
  email: string
  password: string

  plan: string

  emailNotificationsEnabled: boolean = false
  pushnotification: boolean = false
  deploymenttrigger: boolean = false

  public hasImage() {
    return false
  }

  // generate toString() methode
  toString(): string {
    return JSON.stringify(this)
  }
}
